import { Component, OnInit,  Input, ViewContainerRef, ViewChild, ElementRef, TemplateRef, Output, EventEmitter} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
// import {Observable} from 'rxjs/Rx';


import {IboxtoolsComponent} from "../../../components/common/iboxtools/iboxtools.component";



import { MysqlService } from '../../../services/mysql.service';

import { BsModalService } from 'ngx-bootstrap/modal';


import { GlobalFunctionsService } from '../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { SystemLogTypeDataSector } from 'src/app/shared/models/systemLogTypeDataSector.model';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { DataUtil } from '@syncfusion/ej2-data';

@Component({
  selector: 'app-app-route-widget',
  templateUrl: './app-route-widget.component.html',
  styleUrls: ['./app-route-widget.component.scss']
})
export class AppRouteWidgetComponent implements OnInit {


  location: Location;
  // @Output('toggleShow') toggleShow: EventEmitter<any> = new EventEmitter();

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;

  @Input() promotion_id: number;
  @Input() current_route: any;

show_route_id: number;

  all_router_details: string;
  system_automation_id: number;
  nav: any;
  system_automation: any;
  brand_types: Object;
  subject_com_types: Object;
  job_types: Object;
  system_log_type_automation_triggers: Object;
  system_log_type: Object;
  system_log_type_data_sectors: Object;
  array_of_triggers: any;
  system_subject_template_docs_automations: any;
  system_subject_template_docs_automations_commuications: any;
  system_log_type_data_sector_conditions: any;
  allFileAutomations: any;
  allCommunicationsAutomations: any;
  allConditionsAutomations: any;
  model: AppRoute;
  log_type_data_sector_id: number;
  system_log_type_data_sector: any;

  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;
  app_route_id: any;
  app_route: any;

  isShow_sector = false;

  isShow_route_diagram = false;
  isShow_route_tree = false;
  isShow_route_grid = false;
  isShow_route_tree_map = false;
  isShow_route_tree_list = false;
  isShow_route_diagram_hierarchial = false;
  isShow_route_diagram_hierarchial_complex = false;
  isShow_route_diagram_local_data = false;
  isShow_route_diagram_on_init = false;
  isShow_route_diagram_users = false;
  isShow_route_diagram_over_view = false;
  isShow_route_diagram_radial_tree = false;
  isShow_route_diagram_app_network = false;
  isShow_route_diagram_kan_ban = false;
  isShow_route_diagram_kan_ban_children = true;
  isShow_route_diagram_kan_pan_data = true;
  isShow_route_diagram_proposal = false;
  isShow_route_diagram_hierarchial_children = false;

  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  isPlay: boolean = false;
video_name: string;
  app_routes_metrix_search_full: Object;
  app_routes_metrix_search_full_results: any;
  new_data: any;
  search_model: AppRoute;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  modalRef: any;
  app_routes_metrix_search_related: Object;
  app_routes_metrix_search_related_results: any;
  new_data_related: any;
  app_route_related: any;
  get_latest_app_route_id: Object;
  route_app_object: any;
  search_model2: AppRoute;
  app_routes_metrix_search_full_base_route: Object;
  app_routes_metrix_search_full_base_route_results: any;
  new_data_base_route: any;
  app_route_base_route: any;
  search_model_UTH: AppRoute;
  app_routes_metrix_search_all_UTH: Object;
  app_routes_metrix_search_all_UTH_results: any;
  new_data_all_UTH: any;
  app_route_all_UTH: any;


// layouts panels settings dashbards
public cellSpacing: number[] = [10, 10];
public mediaQuery: string = 'max-width: 700px';
public panels: any = [{ "sizeX": 1, "sizeY": 1, "row": 0, "col": 0, content: '<div class="content">0</div>' },
{ "sizeX": 3, "sizeY": 2, "row": 0, "col": 1, content: '<div class="content">1</div>' },
{ "sizeX": 1, "sizeY": 3, "row": 0, "col": 4, content: '<div class="content">2</div>' },
{ "sizeX": 1, "sizeY": 1, "row": 1, "col": 0, content: '<div class="content">3</div>' },
{ "sizeX": 2, "sizeY": 1, "row": 2, "col": 0, content: '<div class="content">4</div>' },
{ "sizeX": 1, "sizeY": 1, "row": 2, "col": 2, content: '<div class="content">5</div>' },
{ "sizeX": 1, "sizeY": 1, "row": 2, "col": 3, content: '<div class="content">6</div>' }
]
public allowResizing: boolean = true;
public resizableHandles: string[] = ['e-south-east','e-east','e-west','e-north','e-south'];
  app_route_all_UTH_count: any;
  search_model_UTH_panel:AppRoute;
  app_routes_metrix_search_all_UTH_panel_results: any;
  new_data_all_UTH_panel: any;
  app_route_all_UTH_panel: any;
  app_route_all_panel_UTH_count: any;
  app_route_related_count: any;
  app_routes_metrix_search_all_UTH_panel: Object;
  app_routes_metrix_search_all_UTH_panelTaskDone: Object;
  app_routes_metrix_search_all_UTH_panel_task_done_results: any;
  new_data_all_UTH_panel_task_done: any;
  app_route_all_UTH_panel_task_done: any;
  app_route_all_panel_UTH_count_task_done: any;


  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }


  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService,
      public toastr: HotToastService,
      private sanitizer: DomSanitizer,
      
  ) {
    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);

     // login vars
    // Set and Access login Session Variables
    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

    // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
    this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    // this.system_automation_id = +this.route.snapshot.paramMap.get('system_automation_id');
    this.app_route_id = +this.route.snapshot.paramMap.get('app_route_id');


   }



 // check for changes. to load data.
 ngOnChanges(changes): void  {
 
  this.model = new AppRoute()
  this.getAppRoutesSearchRelated(''); // get related routes for help articles
  
  if (changes.widget_size) {
  this.widget_size = changes.widget_size.currentValue;
      if (this.widget_size == 'condition'){
      this.isShow_condition_array_example = true;
      }
    }

  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.app_route_id = changes.item_id.currentValue;
   //  this.getBrandById(this.brand_id);
  //  this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash
  //  this.getSystemAutomation(this.system_automation_id);
  this.getAppRoute(this.app_route_id);
      // load the childen tasks
            // this.showLoadRouteDiagramUnderTheHood_ChildrenTASKS('[{}]'); // not owking



  this.getBrandTypes();
  this.getSubjectComTypes();
  this.getJobTypes();
    // this.getBrandUser(this.gfunc.sessionUserId);
    // this.getFormUserLevels();
    // this.getBrands();
  }

  // if current_route set and changes if this component is included 
  if (changes.current_route) {
    this.current_route = changes.current_route.currentValue;

    this.search_model = new AppRoute();

    // this.search_model = {}// set to empty to get all first.
    // Adapt a custom search model to show route info in the topnavbar.
    this.search_model = {
      "routerLink": this.current_route,
      // "routerLinkGeneral": this.current_route // added to show other artivles that are general
      // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
    }// set to empty to get all first.

    if(this.current_route != ''){
    this.getAppRoutesSearchFull(this.search_model);
    this.getAppRoutesSearchRelated(''); // get related routes for help articles
   





    }



    

    if(this.current_route != 'under_the_hood'){


      // "app_route_type_id": 6, // only get BASE_ROUTES
            this.search_model2 = {
              "limit": 100,
              "routerLinkEquals": this.current_route,
              "app_route_type_id": 6, // only get BASE_ROUTES
              "app_route_type_id2": 10 // or type quotes
              // "routerLinkGeneral": this.current_route // added to show other artivles that are general
              // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
            }// set to empty to get all first.
            

            this.getAppRoutesSearchFull_Base_Route(this.search_model2);
            this.getAppRoutesSearchRelated(''); // get related routes for help articles
      }

      if (this.widget_size == 'under_the_hood'){
        this.showLoadRouteDiagramUnderTheHood_ChildrenTASKS_Panel(this.model); // load panel Task items
        this.showLoadRouteDiagramUnderTheHood_ChildrenTASKS_Done_Panel(this.model)
            }

    
  }



}


  ngOnInit(): void {

    this.model = new AppRoute()
    if(this.widget_size == '' || !this.widget_size || this.widget_size == null){
            this.widget_size = 'full'

            this.getAppRoute(this.app_route_id);


            this.getBrandTypes();
            this.getSubjectComTypes();
            this.getJobTypes();
 

    }
    //  this.getSystemAutomation(this.system_automation_id);
  //  this.getSystemLogTypeDataSector(this.log_type_data_sector_id);
  
  
  



  //  let new_model = {
  //   system_automation_array: this.allAutomations
  // }
  // this.getSystemAutomationsArray(new_model);

    // Send the single ID as an array.
            // let new_model = {
            //   system_automation_array: '["' + this.system_automation_id + '"]'
            // }
            // this.getSystemAutomationLogTypeTriggersByArray(new_model);
   
  }






  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
        this.app_route = this.new_data; // sets the data
  
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }


  getAppRoutesSearchFull_Base_Route(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full_base_route = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_full_base_route_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data_base_route = this.app_routes_metrix_search_full_base_route_results.slice(0, 500);
        this.app_route_base_route = this.new_data_base_route; // sets the data
  
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }


  getAppRoutesSearchRelated(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;

// NEED A STRIP FUNCTION HERE
let t = this.current_route
if(t != null){
var newCompareBaseRouteResult = t.substring(0, t.lastIndexOf("/") ); // removes everything up untill the last "/" backslash.
}

this.search_model = {
  "routerLink": this.current_route,
  "routerLinkGeneral": newCompareBaseRouteResult, // added to show other artivles that are general
  "is_active": 1,
  "user_level_id": this.gfunc.sessionUserLevel,
  "limit": 15
  // "app_route_insert_type_id": 5, // tips only

  // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
}// set to empty to get all first.


    this._demoService.getAppRoutesSearchFull(this.search_model).subscribe(
      data => { this.app_routes_metrix_search_related = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_related_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data_related = this.app_routes_metrix_search_related_results.slice(0, 500);
        this.app_route_related = this.new_data_related; // sets the data
  
        this.app_route_related_count =  this.app_routes_metrix_search_related_results.length

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }



  getAppRoutesSearchAllRoutesUnderTheHood(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
this.search_model_UTH = {
  // "routerLink": this.current_route,
  // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
  // "is_active": 1,
  // "user_level_id": this.gfunc.sessionUserLevel,
  "app_route_type_id": 6, // BASE MASER ROUTES ONLY
  "app_route_type_id2": 10, // BASE MASER ROUTES ONLY

  // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
}// set to empty to get all first.


    this._demoService.getAppRoutesSearchFull(this.search_model_UTH).subscribe(
      data => { this.app_routes_metrix_search_all_UTH = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_all_UTH_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data_all_UTH = this.app_routes_metrix_search_all_UTH_results.slice(0, 500);
        this.app_route_all_UTH = this.new_data_all_UTH; // sets the data
        // this.app_route_all_UTH_count = this.app_routes_metrix_search_all_UTH_results.lenght; // sets the data
  
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }



  getAppRoutesSearchAllRoutesUnderTheHood_SearchModel(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;

    // DONE in leading function now 

// this.search_model_UTH = {
//   // "routerLink": this.current_route,
//   // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
//   // "is_active": 1,
//   // "user_level_id": this.gfunc.sessionUserLevel,
//   "app_route_type_id": 6, // BASE MASER ROUTES ONLY
//   "app_route_type_id2": 10, // BASE MASER ROUTES ONLY

//   // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
// }// set to empty to get all first.


    this._demoService.getAppRoutesSearchFull(this.search_model_UTH).subscribe(
      data => { this.app_routes_metrix_search_all_UTH = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_all_UTH_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data_all_UTH = this.app_routes_metrix_search_all_UTH_results.slice(0, 500);
        this.app_route_all_UTH = this.new_data_all_UTH; // sets the data
        // this.app_route_all_UTH_count = this.app_routes_metrix_search_all_UTH_results.lenght; // sets the data
  
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }




  getAppRoutesSearchAllRoutesUnderTheHood_SearchModel_Panel(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;

    // DONE in leading function now 

// this.search_model_UTH = {
//   // "routerLink": this.current_route,
//   // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
//   // "is_active": 1,
//   // "user_level_id": this.gfunc.sessionUserLevel,
//   "app_route_type_id": 6, // BASE MASER ROUTES ONLY
//   "app_route_type_id2": 10, // BASE MASER ROUTES ONLY

//   // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
// }// set to empty to get all first.


    this._demoService.getAppRoutesSearchFull(this.search_model_UTH_panel).subscribe(
      data => { this.app_routes_metrix_search_all_UTH_panel = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_all_UTH_panel_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data_all_UTH_panel = this.app_routes_metrix_search_all_UTH_panel_results.slice(0, 500);
        this.app_route_all_UTH_panel = this.new_data_all_UTH_panel; // sets the data
        this.app_route_all_panel_UTH_count = this.new_data_all_UTH_panel.length; // sets the data
  // this.toastr.success('loading route Tasks')
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }




  getAppRoutesSearchAllRoutesUnderTheHood_SearchModel_PanelTaskDone(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;

    // DONE in leading function now 

// this.search_model_UTH = {
//   // "routerLink": this.current_route,
//   // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
//   // "is_active": 1,
//   // "user_level_id": this.gfunc.sessionUserLevel,
//   "app_route_type_id": 6, // BASE MASER ROUTES ONLY
//   "app_route_type_id2": 10, // BASE MASER ROUTES ONLY

//   // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
// }// set to empty to get all first.


    this._demoService.getAppRoutesSearchFull(this.search_model_UTH_panel).subscribe(
      data => { this.app_routes_metrix_search_all_UTH_panelTaskDone = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_all_UTH_panel_task_done_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data_all_UTH_panel_task_done = this.app_routes_metrix_search_all_UTH_panel_task_done_results.slice(0, 500);
        this.app_route_all_UTH_panel_task_done = this.new_data_all_UTH_panel_task_done; // sets the data
        this.app_route_all_panel_UTH_count_task_done = this.new_data_all_UTH_panel_task_done.length; // sets the data
  // this.toastr.success('loading route Tasks')
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }




// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


  
  private getSystemAutomation(system_automation_id) {
    this._demoService.getSystemAutomation(system_automation_id)
      .subscribe(
        res => {
          this.system_automation = res;
          let data = res[0]


          this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
          this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
          this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

          let new_model = {
            system_file_array: JSON.parse(this.system_automation[0].system_file_array)
          }
          this.getSystemSubjectTemplateDocsArray(new_model);

          let new_model_b = {
            system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
          }
          this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

          
          let new_model_c = {
            system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
          }
          this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);



          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }

  getAppRoute(app_route_id) {
    this._demoService.getAppRoute(app_route_id).subscribe(
       data => { this.app_route = data; 
        let res = data[0];

        this.route_app_object = res
       // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
      
        // this.showLoadRouteDiagramUnderTheHood_ChildrenTASKS_Panel(this.route_app_object); // load panel Task items


      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

   

  private getSystemLogTypeDataSector(log_type_data_sector_id) {
    this._demoService.getSystemLogTypeDataSector(log_type_data_sector_id)
      .subscribe(
        res => {
          this.system_log_type_data_sector = res;
          let data = res[0]


              // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
              // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
              // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

              // let new_model = {
              //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
              // }
              // this.getSystemSubjectTemplateDocsArray(new_model);

              // let new_model_b = {
              //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

              
              // let new_model_c = {
              //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);



          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }

   
   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




  // This needs to send the Automation ID and return LOG TYPES it exists in.
  
  getSystemAutomationLogTypeTriggersByArray(request_array) {
    this._demoService.getSystemAutomationLogTypeTriggersByArray(request_array).subscribe(
       data => { this.system_log_type_automation_triggers = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;



        // I need to do a loop of the entire array not just a single.
        // Then push the logtypeid and names to an new array. - show display array only.

// An array of objects
      // var persons = [{name: "Harry"}, {name: "Alice"}, {name: "Peter"}];
      // var logs_type_triggers = JSON.parse(data[5].system_automation_array);
      // console.log('AutomationArray: ' + logs_type_triggers)
      // if(logs_type_triggers.some(person => person == this.system_automation_id )){
      //   alert("Object found inside the array.");
      // } else{
      //   alert("Object not found.");
      // }



      // Working function to filter and create an array Log Type Items - Triggers Exists in .. (system_automations_array)
this.array_of_triggers = [];
 // Count items of brand search to loop through
 let  count_of_trigger_items = Object.keys(this.system_log_type_automation_triggers).length;
 // now loop and push to join model
 for(let i=0;i < count_of_trigger_items; i++) {
   let res2 = this.system_log_type_automation_triggers[i];
   var logs_type_triggers = JSON.parse(data[i].system_automation_array);
     // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
     if(logs_type_triggers.some(person => person == this.system_automation_id )){

     this.array_of_triggers.push({
    log_type_name: res2.log_type_name,
    log_type_id: res2.log_type_id,
             });

            } // end if exists in the current row array
 
 } // end brands loop.
 
 this.array_of_triggers = this.array_of_triggers;





// Find if the array contains an object by comparing the property value
// if(persons.some(person => person.name === "Peter")){
//     alert("Object found inside the array.");
// } else{
//     alert("Object not found.");
// }


  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }




   getSystemLogType(log_type_id) {
    this._demoService.getSystemLogType(log_type_id).subscribe(
       data => { this.system_log_type = data;
  
        let res = data[0]
        // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
        // this.allAutomations = JSON.parse(this.system_log_type[0].system_automation_array);
        // Lookup the Automations

  
      
      },
       err => console.error(err),
       () => console.log('System Log Type')
     );
   }
  
  
   getSystemLogTypeDataSectors() {
    this._demoService.getSystemLogTypeDataSectors().subscribe(
       data => { this.system_log_type_data_sectors = data;
      
      },
       err => console.error(err),
       () => console.log('System Log Type')
     );
   }
  


   getSystemSubjectTemplateDocsArray(request_array) {
    this._demoService.getSystemSubjectTemplateDocsArray(request_array).subscribe(
       data => { this.system_subject_template_docs_automations = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  
   getSystemSubjectTemplateDocsArray_Communications(request_array) {
    this._demoService.getSystemSubjectTemplateDocsArray_Communications(request_array).subscribe(
       data => { this.system_subject_template_docs_automations_commuications = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  
  
   getSystemSubjectTemplateDocsArray_Conditions(request_array) {
    this._demoService.getSystemSubjectTemplateDocsArray_Conditions(request_array).subscribe(
       data => { this.system_log_type_data_sector_conditions = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  

showAppRouteVideoWidget(app_route_id){
  this.show_route_id = app_route_id;
}





makeDuplicateAppRoute(model){
  if (confirm('We are about duplicate this item, Are you Sure?')) {
  // post a new With this model. & Name as copuy
  model.app_route_name =  model.app_route_name + '_COPY'
  if (model.app_route_description != null){model.app_route_description = '_COPY **** of **** ' + model.app_route_description}
  if (model.app_route_notes != null){model.app_route_notes = '_COPY **** of **** ' + model.app_route_notes}
  if (model.app_route_as_actual_NAME != null){model.app_route_as_actual_NAME = model.app_route_as_actual_NAME + '_COPY'}
  if (model.app_route_as_variable != null){ model.app_route_as_variable = model.app_route_as_variable + '_COPY'}
  if (model.app_route_as_variable_NAME != null){model.app_route_as_variable_NAME = model.app_route_as_variable_NAME + '_COPY'}
  if (model.routerLink != null){model.routerLink = '_COPY **** of **** ' + model.routerLink}
  if (model.routerLinkGeneral != null){model.routerLinkGeneral = '_COPY **** of **** ' + model.routerLinkGeneral}
  if (model.help_content != null){model.help_content = '_COPY **** of **** ' + model.help_content}
  if (model.help_content_HTML != null){model.help_content_HTML = '_COPY **** of **** ' + model.help_content_HTML}
  if (model.video_content != null){model.video_content = '_COPY **** of **** ' + model.video_content}
  if (model.guided_tour_content != null){model.guided_tour_content = '_COPY **** of **** ' + model.guided_tour_content}
  model.app_route_1  = '';
  model.app_route_2  = '';
  model.app_route_3  = '';
  model.app_route_4  = '';
  model.app_route_5  = '';
  model.help_content_HTML  = '';
  model.help_content  = '';
  model.video_content  = '';
  model.guided_tour_content  = '';

  // model.is_active = '';
  this.createAppRoute(model);

  }
}
createAppRoute(model) {
  // console.log(model);
    this._demoService.createAppRoute(model).subscribe(
          data => {  this.get_latest_app_route_id = data; // this is the retuned json upon creation.

          this.toastr.success('App Route Added!');
           
  /*
          // tslint:disable-next-line:max-line-length
          this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
          this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
  */
          // this.closeParentModel.emit();
        //   CreateJobTypeComponent.returned.next(false);
            //  return true;
          },
          error => {
            this.toastr.error('Adding App Route Failed :: Please try again!');
            // console.log(Observable.throw(error));
            // return Observable.throw(error);
          console.error(error);
          }
    );
    }



// All Base Routes Under The Hood For Diaram -- So To Add New BASE CHILD ROUTE
  showLoadRouteDiagramUnderTheHood(model){
    // this.search_model2 = {
    //   // file_number: model.file_number,
    //   // file_number_selector: 'less',
    //   // project_id: model.project_id
    // }// set to empty to get all first.
    this.getAppRoutesSearchAllRoutesUnderTheHood(model);
  }
  

  showLoadRouteDiagramUnderTheHood_Parents(model){
    // this.search_model2 = {
    //   // file_number: model.file_number,
    //   // file_number_selector: 'less',
    //   // project_id: model.project_id
    // }// set to empty to get all first.

    this.search_model_UTH = {
      // "routerLink": this.current_route,
      // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
      // "is_active": 1,
      // "user_level_id": this.gfunc.sessionUserLevel,
      // "app_route_type_id": 6, // BASE MASER ROUTES ONLY
      // "app_route_type_id2": 10, // BASE MASER ROUTES ONLY
      file_number: model.file_number,
      file_number_selector: 'less'
    
      // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
    }// set to empty to get all first.


    this.getAppRoutesSearchAllRoutesUnderTheHood_SearchModel(model);
  }
  




  showLoadRouteDiagramUnderTheHood_Children(model){
    // this.search_model2 = {
    //   // file_number: model.file_number,
    //   // file_number_selector: 'less',
    //   // project_id: model.project_id
    // }// set to empty to get all first.

    this.search_model_UTH = {
      // "routerLink": this.current_route,
      // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
      // "is_active": 1,
      // "user_level_id": this.gfunc.sessionUserLevel,
      // "app_route_type_id": 6, // BASE MASER ROUTES ONLY
      // "app_route_type_id2": 10, // BASE MASER ROUTES ONLY
      file_number: model.file_number,
      file_number_selector: 'greater'
    
      // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
    }// set to empty to get all first.


    this.getAppRoutesSearchAllRoutesUnderTheHood_SearchModel(model);
  }
  



  showLoadRouteDiagramUnderTheHood_ChildrenTASKS(model){
    // this.search_model2 = {
    //   // file_number: model.file_number,
    //   // file_number_selector: 'less',
    //   // project_id: model.project_id
    // }// set to empty to get all first.

    // model.app_route_id = this.app_route_id // set above so loads when route loads on the under the hood component.

    this.search_model_UTH = {
      // "routerLink": this.current_route,
      // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
      // "is_active": 1,
      // "user_level_id": this.gfunc.sessionUserLevel,
      "app_route_type_id": 32, // tasks
      // "app_route_type_id2": 10, // BASE MASER ROUTES ONLY
      // file_number: model.file_number,
      // file_number_selector: 'greater'
      "app_route_parent_id": model.app_route_id,
      "routerLink": model.routerLink
      // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
    }// set to empty to get all first.


    this.getAppRoutesSearchAllRoutesUnderTheHood_SearchModel(model);
  }
  



  // Now working for UNDER THE HOOD!!!!! panel...YES
  showLoadRouteDiagramUnderTheHood_ChildrenTASKS_Panel(model){
    // this.search_model2 = {
    //   // file_number: model.file_number,
    //   // file_number_selector: 'less',
    //   // project_id: model.project_id
    // }// set to empty to get all first.

    // model.app_route_id = this.app_route_id // set above so loads when route loads on the under the hood component.

    this.search_model_UTH_panel = {
      // "routerLink": this.current_route,
      // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
      // "is_active": 1,
      // "user_level_id": this.gfunc.sessionUserLevel,
      "app_route_type_id": 32, // tasks
      // "app_route_type_id2": 10, // BASE MASER ROUTES ONLY
      // file_number: model.file_number,
      // file_number_selector: 'greater'
      "app_route_parent_id": this.app_route_id,
      "routerLink": this.current_route,
      "app_route_insert_type_id_NOT": "16"
      // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
    }// set to empty to get all first.


    this.getAppRoutesSearchAllRoutesUnderTheHood_SearchModel_Panel(model);
  }
  


    // Now working for UNDER THE HOOD!!!!! panel...YES
    showLoadRouteDiagramUnderTheHood_ChildrenTASKS_Done_Panel(model){
      // this.search_model2 = {
      //   // file_number: model.file_number,
      //   // file_number_selector: 'less',
      //   // project_id: model.project_id
      // }// set to empty to get all first.
  
      // model.app_route_id = this.app_route_id // set above so loads when route loads on the under the hood component.
  
      this.search_model_UTH_panel = {
        // "routerLink": this.current_route,
        // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
        // "is_active": 1,
        // "user_level_id": this.gfunc.sessionUserLevel,
        "app_route_type_id": 32, // tasks
        "app_route_insert_type_id": 16, // tasks
        // "app_route_type_id2": 10, // BASE MASER ROUTES ONLY
        // file_number: model.file_number,
        // file_number_selector: 'greater'
        "app_route_parent_id": this.app_route_id,
        "routerLink": this.current_route
        // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
      }// set to empty to get all first.
  
  
      this.getAppRoutesSearchAllRoutesUnderTheHood_SearchModel_PanelTaskDone(model);
    }


  // showLoadKanPanChildren(){
  //   this.search_model = {
  //     app_route_parent_id: this.app_route_id,
  //   }// set to empty to get all first.
  //   this.getAppRoutesSearchFull(this.search_model);
  // }
  

}

